import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-charcoal text-white pt-16 pb-24 lg:pb-12" data-id="element-479" data-mp="en8zt2o07c54">
      <div className="max-w-7xl mx-auto px-4" data-id="element-480" data-mp="elxyd9i16gh6">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-[1.45fr_0.8fr_1fr_1.15fr_1.35fr] lg:gap-6 xl:gap-8 mb-12" data-id="element-481" data-mp="al4auh8i33ot">
          {/* Brand Column */}
          <div className="space-y-6" data-id="element-482" data-mp="nptmfer6avg">
            <img src="https://www.midatlanticmailboxes.com/uploaded/images/Redesign/Logo%201.png" alt="MidAtlantic Mailboxes Logo" className="h-12 bg-white p-2 rounded" data-id="element-483" data-mp="oretcphgdqw" />
            <p className="max-w-[320px] text-[#DAD7D2] text-sm leading-relaxed" data-id="element-484" data-mp="3n1hlrrw0t4ob">
              Residential mailboxes, commercial delivery systems, address
              plaques, decorative signs, replacement parts, and exterior
              accents.
            </p>
          </div>

          {/* Company Links */}
          <div data-id="element-485" data-mp="3965i2uzw03v9">
            <h4 className="font-serif text-lg font-semibold mb-6 text-brand-gold" data-id="element-486" data-mp="2kdczgky7ulmz">
              Company
            </h4>
            <ul className="space-y-3 text-sm text-[#E2DFDD]" data-id="element-487" data-mp="2p433nuuwoig3">
              <li data-id="element-488" data-mp="2bcev21jv8c3v">
                <a href="/AboutMidAtlanticMailboxInc.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-489" data-mp="2bcyczi9in0hw">
                  About Us
                </a>
              </li>
              <li data-id="element-490" data-mp="341lr8tvukply">
                <a href="/3949.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-491" data-mp="33yzjat51o837">
                  Our Gallery
                </a>
              </li>
              <li data-id="element-492" data-mp="2z1r0cqc2o00w">
                <a href="/ContactUs.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-493" data-mp="2z17vobbfn84t">
                  Contact & FAQs
                </a>
              </li>
              <li data-id="element-494" data-mp="1nof4p2qgunpt">
                <a href="/OurPolicies" className="hover:text-brand-gold hover:underline transition-all" data-id="element-495" data-mp="1nkras2h3zzak">
                  Our Policies
                </a>
              </li>
            </ul>
          </div>

          {/* Resources Links */}
          <div data-id="element-496" data-mp="uqbaiziqhr9o">
            <h4 className="font-serif text-lg font-semibold mb-6 text-brand-gold" data-id="element-497" data-mp="uq30rghwr22p">
              Resources
            </h4>
            <ul className="space-y-3 text-sm text-[#E2DFDD]" data-id="element-498" data-mp="kuriio7ajcq7">
              <li data-id="element-499" data-mp="ks5dav7vh9b5">
                <a href="/Services.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-500" data-mp="fv578kb0w6k1">
                  Services
                </a>
              </li>
              <li data-id="element-501" data-mp="6v8muuvo1tus">
                <a href="/13.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-502" data-mp="6vs2g4xug65n">
                  Install Instructions
                </a>
              </li>
              <li data-id="element-503" data-mp="216f21qg1102i">
                <a href="/USPSResources.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-504" data-mp="28s0rfraqcz1z">
                  USPS Resources
                </a>
              </li>
              <li data-id="element-505" data-mp="2iivbqq4f1oks">
                <a href="/product-option-patterns.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-506" data-mp="2iic3y28hcgkh">
                  Product Option Patterns
                </a>
              </li>
              <li data-id="element-507" data-mp="1urpuq7mqoq8w">
                <a href="/29.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-508" data-mp="1utap9x92096r">
                  Catalog
                </a>
              </li>
              <li data-id="element-509" data-mp="23uhb8luh2c7e">
                <a href="/3948.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-510" data-mp="23qthbll47ns5">
                  Dominion Valley Community
                </a>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div data-id="element-511" data-mp="3dt09t7m302cv">
            <h4 className="font-serif text-lg font-semibold mb-6 text-brand-gold" data-id="element-512" data-mp="38ruer34y8306">
              Shop Categories
            </h4>
            <ul className="space-y-3 text-sm text-[#E2DFDD]" data-id="element-513" data-mp="3npdcguzltqjr">
              <li data-id="element-514" data-mp="3nmqwc6yne2px">
                <a href="/6m8/mailboxes.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-515" data-mp="3iqa9dg36puef">
                  Mailboxes
                </a>
              </li>
              <li data-id="element-516" data-mp="3rpx97xg9ms5d">
                <a href="/6m8/mailbox-posts.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-517" data-mp="3rqf1kizt4m80">
                  Mailbox Posts
                </a>
              </li>
              <li data-id="element-518" data-mp="jalxx4qkr58d">
                <a href="/6m8/commercial-mailboxes-lockers.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-519" data-mp="ja3t3jpujiou">
                  Commercial Mailboxes
                </a>
              </li>
              <li data-id="element-520" data-mp="xvrflbjiuzav">
                <a href="/6m8/street-signs-traffic-signs.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-521" data-mp="12wf1xjwt2ryr">
                  Street Signs & Traffic Signs
                </a>
              </li>
              <li data-id="element-522" data-mp="ty3gdwasqkd6">
                <a href="/6m8/decorative-signage.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-523" data-mp="f72y6zk8zc3u">
                  Decorative Signage
                </a>
              </li>
              <li data-id="element-524" data-mp="67pjnsh9nxc9">
                <a href="/6m8/outdoor-accessories-home-accents.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-525" data-mp="6892dbeqqprc">
                  Outdoor Accessories & Home Accents
                </a>
              </li>
              <li data-id="element-526" data-mp="1609sg5s5ppr">
                <a href="/6m8/lighting.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-527" data-mp="16jolo04vxzk">
                  Lighting
                </a>
              </li>
              <li data-id="element-528" data-mp="1u46xrmyxnpyt">
                <a href="/6m8/mailboxes/mailbox-replacement-parts-and-accessories.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-529" data-mp="1u3np6wv6adxg">
                  Mailbox Parts & Accessories
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div data-id="element-530" data-mp="2hrncfmt9zm7a">
            <h4 className="font-serif text-lg font-semibold mb-6 text-brand-gold" data-id="element-531" data-mp="2cuom7fcqfzed">
              Contact Us
            </h4>
            <ul className="space-y-4 text-sm text-[#E2DFDD]" data-id="element-532" data-mp="27w3n5j97vlri">
              <li className="flex items-start gap-3" data-id="element-533" data-mp="27xy5qqx0n1sf">
                <Phone size={18} className="shrink-0 mt-0.5 text-brand-gold" data-id="element-534" data-mp="11gji8mcirpj1" />
                <a href="tel:301-620-7585" className="hover:text-brand-gold transition-colors" data-id="element-535" data-mp="wfvmxoh9cmj0">
                  301-620-7585
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-536" data-mp="rcmid454qmqm">
                <MapPin size={18} className="shrink-0 mt-0.5 text-brand-gold" data-id="element-537" data-mp="wao1fp2k2m23" />
                <span className="text-[#DAD7D2]" data-id="element-538" data-mp="w8l38hr91mma">
                  MidAtlantic Mailbox, Inc.
                  <br data-id="element-539" data-mp="113h6ke1xrwep" />
                  4507 Metropolitan Court Ste. D<br data-id="element-540" data-mp="153r9fhufm6pc" />
                  Frederick, MD 21704
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-541" data-mp="1a19jxco3ktzg">
                <Clock size={18} className="shrink-0 mt-0.5 text-brand-gold" data-id="element-542" data-mp="1a3vvdne3ztmy" />
                <span className="text-[#DAD7D2]" data-id="element-543" data-mp="1f1xajx8ez8t5">
                  East Coast: Mon–Fri 10:30am–5:00pm EST
                  <br data-id="element-544" data-mp="1jy5x3voxy4ac" />
                  West Coast: Mon–Fri 9:00am–5:00pm MST
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#DAD7D2]" data-id="element-545" data-mp="3lsn3vbgwivtw">
          <p data-id="element-546" data-mp="1rhevyuztmkl5">
            &copy; {new Date().getFullYear()} MidAtlantic Mailbox, Inc. All
            rights reserved.
          </p>
          <div className="flex items-center gap-4" data-id="element-547" data-mp="21a2p9frle6f4">
            <span data-id="element-548" data-mp="218rrbwktvsvx">Family-Owned</span>
            <span data-id="element-549" data-mp="1waq7h9fkvpje">•</span>
            <span data-id="element-550" data-mp="1wbj59kwk74pe">Woman-Owned</span>
          </div>
        </div>
      </div>
    </footer>;
}